<template>
  <div class="container-fluid">
    <!-- Page Heading -->
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Customer Summary</h6>
      </div>
      <div class="card-body text-align-left" v-if="customerData">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <p class="col-6 no-margin">
                  ID:
                </p>
                <p class="col-6 no-margin">
                  {{customerData.ID}}<br>
                </p>
                <p class="col-6 no-margin">
                  Customer Name:
                </p>
                <p class="col-6 no-margin">
                  {{customerData.Name}}<br>
                </p>
                <p class="col-6 no-margin">
                  Customer Email:
                </p>
                <p class="col-6 no-margin">
                  {{customerData.Email}}<br>
                </p>
                <p class="col-6 no-margin">
                  Customer City:
                </p>
                <p class="col-6 no-margin">
                  {{customerData.city}}<br>
                </p>
            </div>
            <br>
            <br>
            <div class="row">
              <marketplaces-grid
                :data="gridData"
                :columns="gridColumns"
                :filter-key="searchQuery"
              />
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import bPagination from 'bootstrap-vue/esm/components/pagination/pagination';
import {GridTable} from '@dmunoz/gridtable';
import CustomerApiRequest from '@/components/ApiRequester/Customer.js';
//import bTabs  from 'bootstrap-vue/esm/components/tabs/tabs';
//import bTab  from 'bootstrap-vue/esm/components/tabs/tab';

export default {
  name: 'home',
  components: {
    'marketplaces-grid': GridTable,
    //'b-pagination': bPagination,
  },
    data() {
    return {
      customerData: undefined,
      gridData: [],
      gridColumns: [
        {
          column: 'Order ID', index: 'OrderID', type: 'raw',
        },
        {
          column: 'SKUs', index: 'SKUs', type: 'raw',
        },
        {
          column: 'Recipient', index: 'Recipient', type: 'raw',
        },
        {
          column: 'Quantity', index: 'Qty', type: 'raw',
        },
        {
          column: 'Order Total', index: 'OrderTotal', type: 'raw',
        },
        {
          column: 'Date', index: 'Date', type: 'raw',
        },
      ],
    }
  },
  computed: {

  },
  mounted() {
      this.marketplace = this.$route.params.marketplace;
      document.getElementById('loader').classList.add('active');
      const customerApiRequest = new CustomerApiRequest();
      let payload = {
        customer_id: this.$route.params.id,
        marketplace: this.$route.params.marketplace
      };
       customerApiRequest.detail(payload).then((response) => {
          this.customerData = response.data.customer;
          this.gridData = response.data.orders;
          console.log(this.customerData);
          document.getElementById('loader').classList.remove('active');
       }).catch(() => {
         document.getElementById('loader').classList.remove('active');
       });
  },
  methods: {


  }
};
</script>

